import { FC } from 'react';
import {
  Button,
  Typography,
  StyledDiv,
  Audio,
  IconText,
} from '@taleemabad/dsm/components';

interface MembersInvitedProps {
  audioSrc: string;
  onAddAnotherMember?: () => void;
  onBackToList?: () => void;
}
export const MemberInvited: FC<MembersInvitedProps> = ({
  audioSrc,
  onAddAnotherMember,
  onBackToList,
}) => {
  const handleAddAnotherMember = () => {
    onAddAnotherMember?.(); // Replace with actual logic
  };

  const handleBackToList = () => {
    onBackToList?.(); // Replace with actual logic
  };

  return (
    <StyledDiv gap={16} flexDirection="column">
      <StyledDiv flexDirection="column" height="calc(100vh - 152px)" gap={24}>
        <Audio isPlaying={true} src={audioSrc} />
        <IconText
          icon="check_circle"
          iconColor="--md-sys-color-on-success"
          text="Teacher Invited"
          textVariant="textTitleLarge"
        />
        <Typography variant="textBodyLarge">
          The teacher was added and an invite has been sent to their Whatsapp
          number.
        </Typography>
      </StyledDiv>
      <Button variant="filled" onClick={handleAddAnotherMember}>
        Add Another Teacher
      </Button>
      <Button variant="outlined" onClick={handleBackToList}>
        Back to Teacher’s List
      </Button>
    </StyledDiv>
  );
};
